var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDescending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.132,
    height: 13.948,
    viewBox: "0 0 13.132 13.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30784",
    "data-name": "Group 30784",
    transform: "translate(-343.295 -326.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-left",
    "data-name": "Icon awesome-arrow-left",
    d: "M2.532,8.071l.3.3a.318.318,0,0,0,.451,0L5.867,5.78a.318.318,0,0,0,0-.451L3.279,2.741a.318.318,0,0,0-.451,0l-.3.3a.32.32,0,0,0,.005.457l1.6,1.528H.316A.319.319,0,0,0,0,5.341v.426a.319.319,0,0,0,.319.319H4.142l-1.6,1.528A.318.318,0,0,0,2.532,8.071Z",
    transform: "translate(346.852 323.354)",
    fill: "#555"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67926",
    "data-name": "Path 67926",
    d: "M2.356-.8H5.322V.577H.45V-.7L3.4-4.943H.45V-6.318H5.322v1.277Zm9.036.157H8.819L8.406.577H6.648l2.495-6.9h1.945l2.495,6.9H11.8Zm-.432-1.3-.855-2.524L9.261-1.937Z",
    transform: "translate(342.845 339.372)",
    fill: "#555"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescending);
export default __webpack_public_path__ + "static/media/descending.01551f67710802fd34cff7fa1283e345.svg";
export { ForwardRef as ReactComponent };